<div class="visualiser-component">
  <a (click)="backToList()">{{ visualiserMessages.retour | translate }}</a>
  <div class="d-flex mt-4 mb-4">
    <h3 class="mt-auto">{{ visualiserMessages.libelle | translate }}{{ referenceAvis }}
      <span class="tag {{statusobs | async | lowercase}}">{{statusobs | async}}</span>
    </h3>
    <div class="ml-auto">
      <button class="btn btn-outline-primary mt-auto" [disabled]="!hasManageRight"
              (click)="telecharger()" >{{ visualiserMessages.telecharger | translate }}</button>
      <button class="btn btn-outline-primary mt-auto" [disabled]="(statusobs | async) != 'ELABORE' || !hasManageRight"
              (click)="supprimer()" >{{ visualiserMessages.supprimer | translate }}</button>
      <button class="btn btn-outline-primary mt-auto"  [disabled]="(statusobs | async) != 'ELABORE' || !hasManageRight"
              (click)="modifier()" >{{ visualiserMessages.modifier | translate }}</button>
      <button class="btn btn-outline-primary mt-auto" [disabled]="!hasManageRight"
              (click)="dupliquer()" >{{ visualiserMessages.dupliquer_avis | translate }}</button>
      <button class="btn btn-outline-primary mt-auto" [disabled]="(statusobs | async) != 'PUBLIE' || !isLiable() || !hasManageRight"
              (click)="lierAvis()" >{{ visualiserMessages.creer_avis | translate }}</button>
      <button class="btn btn-outline-primary mt-auto" [disabled]="linkableNotices.length == 0 || !hasManageRight"
              (click)="lierAvisPub()" >{{ visualiserMessages.lie_avis | translate }}</button>
    </div>
  </div>
  <div>
    <div class="report-block">
      <div class="row">
        <div class="col-lg-12 col-md-10">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <a (click)="activeTab(1)" aria-controls="pills-one" aria-selected="true"
                 class="nav-link active" data-toggle="pill" id="pills-one-tab"
                 role="tab">{{ visualiserMessages.synthese | translate }}</a>
            </li>
            <li class="nav-item" role="presentation">
              <a (click)="activeTab(2)" aria-controls="pills-two" aria-selected="true"
                 class="nav-link" data-toggle="pill" id="pills-two-tab"
                 role="tab">{{ visualiserMessages.historique | translate }}</a>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div *ngIf="isNewActive!==2" aria-labelledby="pills-one-tab" class="tab-pane fade show active"
                 id="pills-one"
                 role="tabpanel">
              <app-synthese [referenceAvis]="referenceAvis" ></app-synthese>
            </div>
            <div *ngIf="isNewActive!==1" aria-labelledby="pills-three-tab"
                 class="tab-pane fade show active signature-header" id="pills-three"
                 role="tabpanel">
              <app-historique [referenceAvis]="referenceAvis" ></app-historique>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
